import { defineMessages } from 'react-intl';

export default defineMessages({
    standardizingAddressMessage: {
        id: 'quoteandbind.eu.views.eu-policydetails-details.Standardizing address...',
        defaultMessage: 'Standardizing address...'
    },
    loadingNextPageMessage: {
        id: 'quoteandbind.eu.views.eu-policydetails-details.Loading next page...',
        defaultMessage: 'Loading next page...'
    },
    creatingYourSubmissionMessage: {
        id: 'quoteandbind.eu.views.eu-policydetails-details.Creating your submission...',
        defaultMessage: 'Creating your submission...'
    },
    startDate: {
        id: 'quoteandbind.eu.views.eu-policy-info.Coverage Start Date',
        defaultMessage: 'Coverage Start Date'
    },
    rateAsOfDate: {
        id: 'quoteandbind.eu.views.eu-policy-info.Rate as of Date',
        defaultMessage: 'Rate as of Date'
    },
    middleName: {
        id: 'gateway.views.new-quote.M.I.',
        defaultMessage: 'M.I.'
    },
    suffix: {
        id: 'gateway.views.new-quote.Suffix',
        defaultMessage: 'Suffix'
    },
    chooseSuffix: {
        id: 'quoteandbind.inputs.address-details.Choose Suffix',
        defaultMessage: '--Choose Suffix--'
    },
    insuredResidenceInformation: {
        id: 'quoteandbind.wizard.step.Policy Details.Insured Residence Information',
        defaultMessage: 'Insured Residence Information'
    },
    Optional: {
        id: 'quoteandbind.eu.views.eu-policydetails-details.optional',
        defaultMessage: 'Optional'
    },
    insuredInformation: {
        id: 'quoteandbind.eu.views.eu-policydetails-details.Insured Information',
        defaultMessage: 'Insured Information'
    },
    accountTypeErrorMessage: {
        id: 'quoteandbind.eu.views.eu-policydetails-details.Account type must be a Company or a Person',
        defaultMessage: 'Account type must be a Company or a Person'
    },
    newAccountCreateErrorMessage: {
        id: 'quoteandbind.eu.views.eu-policydetails-details.Could not create the Account',
        defaultMessage: 'Could not create the Account'
    },
    sourceType: {
        id: 'gateway.views.new-quote.Source Type',
        defaultMessage: 'Source of Entry'
    },
    agencyName: {
        id: 'gateway.views.new-quote.AgencyName',
        defaultMessage: 'Agency Name'
    },
    agencyInfo: {
        id: 'quoteandbind.wizard.step.Agency Information',
        defaultMessage: 'Agency Information'
    },
    effDate: {
        id: 'quoteandbind.eu.views.eu-policy-info.Effective Date',
        defaultMessage: 'Effective Date'
    },
    expDate: {
        id: 'quoteandbind.eu.views.eu-policy-info.Expiration Date',
        defaultMessage: 'Expiration Date'
    },
    riskState: {
        id: 'quoteandbind.eu.views.eu-policy-info.Risk State',
        defaultMessage: 'Risk State'
    },
    Yes: {
        id: 'quoteandbind.eu.wizard.step.Policy Details.Yes',
        defaultMessage: 'Yes'
    },
    No: {
        id: 'quoteandbind.eu.wizard.step.Policy Details.No',
        defaultMessage: 'No'
    },
    removePriorAddress: {
        id: 'quoteandbind.controllers.underwriting-details.Remove Prior Address?',
        defaultMessage: 'Remove Prior Loss Address?'
    },
    removePriorAddressDescription: {
        id: 'quoteandbind.underwriting-details.remove-loss.Please note that this action will remove provided prior address.',
        defaultMessage: 'Please note that this action will remove provided prior address.'
    }
});
